import api from 'services/api';

export const OAUTH_FETCH_CLIENT_INFO = 'oauth/fetchClientInfo';
export const OAUTH_GET_AUTHORIZATION = 'oauth/getAuthorization';
export const OAUTH_CREATE_AUTHORIZATION = 'oauth/createAuthorization';
export const OAUTH_FETCH_CONSENT_INFO = 'oauth/fetchConsentInfo';
export const OAUTH_CREATE_CONSENT = 'oauth/createConsent';

export default {
  fetchClientInfo(query) {
    return {
      type: OAUTH_FETCH_CLIENT_INFO,
      payload: api.get('/oauth/client', query).catch((error) => ({ error })),
    };
  },

  getAuthorization(query) {
    return {
      type: OAUTH_GET_AUTHORIZATION,
      payload: api.get('/oauth/authorization', query),
    };
  },

  createAuthorization(data) {
    return {
      type: OAUTH_CREATE_AUTHORIZATION,
      payload: api.post('/oauth/authorizations', data),
    };
  },

  // OAuth 2.1 consent for MCP connectors
  fetchConsentInfo(query) {
    return {
      type: OAUTH_FETCH_CONSENT_INFO,
      payload: api
        .get('/oauth2/authorize-info', query)
        .catch((error) => ({ error })),
    };
  },

  createConsent(data) {
    return {
      type: OAUTH_CREATE_CONSENT,
      payload: api.post('/oauth2/authorizations', data),
      // The consent page shows why the server refused
      meta: { manuallyHandleErrors: true },
    };
  },
};

export const initialState = {
  app: null,
  user: null,
  scope: {},
  consent: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case OAUTH_FETCH_CLIENT_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case OAUTH_FETCH_CONSENT_INFO:
      return {
        ...state,
        consent: action.payload || null,
      };

    default:
      return state;
  }
}
